// ============================================================================
// CASE OPPOSITE PARTIES HOOK — Phase 9b-2
// ============================================================================

import { useState, useEffect, useCallback } from 'react';
import { caseOppositePartyService } from '../../api/services/caseOppositePartyService';
import type { CaseOppositeParty } from '../../api/types/caseOppositeParty.types';
import type { ID } from '../../api/types';

export const useCaseOppositeParties = (caseId: ID | undefined) => {
  const [data, setData] = useState<CaseOppositeParty[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!caseId) { setData([]); return; }
    setLoading(true); setError(null);
    try {
      const response = await caseOppositePartyService.getByCase(caseId);
      setData(response.data ?? []);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [caseId]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
